import { VHeaders } from '@/models/pagedlistmodel';



export function getInvoiceConfigHeaders(vm: any): VHeaders[] {
  return [
    {
      text: 'Key',
      align: 'left',
      value: 'key',
      sortable: true,
    },
    {
      text: 'Value',
      align: 'left',
      value: 'value',
    },
    {
      text: vm.$parent.$t('shifts.shiftGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
